import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { observer } from 'mobx-react'
import { 
    Button,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Modal
} from 'react-bootstrap'

@observer(['globals', 'invoices'])
export default class TrackingNumberModal extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            trackingNumber: ''
        };
    }

    loadTrackingNumber(props) {
        props.invoices.loadTrackingNumber(props.invoiceId, (trackingNumber) => {
            this.setState({ trackingNumber });
        });
    }

    componentDidMount() {
        if (this.props.invoiceId) {
            this.loadTrackingNumber(this.props);
        }
    }

    closeTrackingNumberModal() {        
        if (this.props.onClose) {
            this.props.onClose()            
        }
    }

    trackingNumberChanged(e) {
        this.setState({
            trackingNumber: e.target.value
        })
    }

    saveTrackingNumber() {
        this.props.setLoadableState(true)
        this.closeTrackingNumberModal()
        this.props.invoices.saveTrackingNumber(this.props.invoiceId, this.state.trackingNumber, () => {
            this.props.reload(() => {
                alert('Tracking number successfully saved.')
            })
        })
    }

    render() {

        return (
            <Modal show={this.props.open} onHide={this.closeTrackingNumberModal.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enter Tracking Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form horizontal name="trackingNumberForm">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <FormGroup>
                                <Col sm={4} componentClass={ ControlLabel } >Tracking Number:</Col>
                                <Col sm={8}><FormControl type="text" placeHolder="Tracking Number" id="trackingNumber" onChange={ this.trackingNumberChanged.bind(this) } value={ this.state.trackingNumber } /></Col>
                            </FormGroup>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={ this.saveTrackingNumber.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
                    <Button bsStyle="danger" onClick={ this.closeTrackingNumberModal.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invoices/trackingnumbermodal.js